<template>
  <div>
    <v-btn :outline="selectedCount === 0"
           color="primary"
           class="ma-0"
           @click="showModal">
      {{buttonText}}
    </v-btn>

    <v-dialog v-model="modal" :max-width="350" class="enrolment-status-dialog">
      <v-card>
        <v-card-title class="justify-center">
          <h2>{{buttonTitle}}</h2>
        </v-card-title>
        <v-card-text class="pt-0 pl-4 pr-4">
          <v-text-field clearable
                        append-icon="search"
                        v-model="searchText"
                        :placeholder="$t('student.filters.list_search_placeholder')"
                        class="enrolment-status-search" />
          <div v-if="modal" class="filter-list-rows scrollable">
            <transition-group name="filter-list">
              <v-checkbox v-for="(item, index) in filteredRows"
                          multiple
                          v-model="selectedEnrolment"
                          :key="index"
                          :value="item.code"
                          color="primary"
                          class="enrolment-status-checkbox mb-3">
                <div slot="label">
                  <div>{{item.description}}</div>
                  <div>{{item.code}}</div>
                </div>
              </v-checkbox>
            </transition-group>
          </div>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-layout row justify-center class="ma-0">
            <v-btn @click="clear" :disabled="selectedCount === 0">{{$t('student.filters.clear')}}</v-btn>
            <v-btn @click="closeModal" color="primary">{{$t('student.filters.okay')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helpers from '../../mixins/Helpers'
import { SET_DATA_PURGE_PAGE_NUMBER, SET_SELECTED_ENROLMENT_STATUS } from '../../store/mutation-types'
import { mapActions, mapMutations } from 'vuex'
import { GET_DATA_PURGE_STUDENTS } from '../../store/action-types'

export default {
  name: 'EnrolmentStatusSelection',
  mixins: [Helpers],
  data () {
    return {
      modal: false,
      searchText: '',
      selectedCount: 0,
      title_i18n: 'student.filters.headers.enrolment_status',
      button_i18n: '{count} student.filters.headers.enrolment_status ::: {count} student.filters.headers.enrolment_status_additional_description',
      button_unselected_i18n: 'student.filters.headers.enrolment_status_additional_description'
    }
  },
  props: {
    enrolmentStatus: {
      required: true,
      type: Array
    }
  },
  methods: {
    ...mapMutations({
      setSelectedEnrolmentStatus: SET_SELECTED_ENROLMENT_STATUS,
      setPageNumber: SET_DATA_PURGE_PAGE_NUMBER
    }),
    ...mapActions({
      getStudents: GET_DATA_PURGE_STUDENTS
    }),
    showModal () {
      this.modal = true
    },
    closeModal () {
      this.modal = false
    },
    clear () {
      this.selectedCount = 0
      this.setSelectedEnrolmentStatus([])
    }
  },
  computed: {
    selectedEnrolment: {
      get () {
        return this.$store.state.dataPurge.selectedEnrolment
      },
      set (value) {
        this.selectedCount = value.length
        this.$store.commit(SET_SELECTED_ENROLMENT_STATUS, value)
      }
    },
    buttonTitle () {
      return this.$t(this.title_i18n) + ' ' + this.$t('selection_label')
    },
    buttonText () {
      if (this.selectedCount === 0) {
        return this.$t('all_label') + ' ' + this.$t(this.button_unselected_i18n)
      } else {
        // original
        let x = this.$t(this.button_i18n, {count: this.selectedCount}, this.selectedCount)
        // remove count to look up in translations
        let y = this.$t(x.substring(x.indexOf(this.selectedCount) + this.selectedCount.toString().length + 1, x.length))
        // re-apply count to translated text
        return this.selectedCount + ' ' + y
      }
    },
    filteredRows () {
      let text = (this.searchText === null) ? '' : this.searchText.trim()
      return this.enrolmentStatus.filter(item => (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0) ||
        (item.description.toUpperCase().indexOf(text.toUpperCase()) >= 0))
    }
  },
  watch: {
    selectedEnrolment (value) {
      if (value.length === 0) {
        this.selectedCount = 0
        this.setPageNumber(0)
      }
    }
  }
}
</script>

<style scoped>
  .filter-list-rows {
    overflow: auto;
    height: 55vh;
    max-height: calc(100vh - 340px);
    -webkit-overflow-scrolling: touch;
  }
    /* Transitions */
  .filter-list-enter-active,
  .filter-list-leave-active {
    transition: all 0.4s;
    opaque: 1;
  }

  .filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translate(-16px, 0px)
  }
</style>



// WEBPACK FOOTER //
// src/components/data-purge/EnrolmentStatusSelection.vue